import React, { ReactElement, ReactNode } from 'react';
import '../../../lib/Error/slideErrorStyle.scss';
import Menu from '../Menu';
import Resources from '../Resources';
import Helper from '../Helper';
import QuizHelper from '../QuizHelper';
import { ErrorBoundary } from 'react-error-boundary';
import { errorHandler } from '@/lib/Error';
import { FaqType, HelperType } from '@/modules/types/helper';
import { FrameDataType } from '@/modules/types/frame';
import { ElearningDataType } from '@/modules/types/elearning';
import { ResourceType } from '@/modules/types/resource';
import config from '@/lib/config';
import { SlideErrorFallback } from '@/lib/Error/slideErrorFallBack';

interface PlayerLayoutType {
  top: ReactNode;
  canvas: ReactNode;
  bottom: ReactNode;
  className: string | null;
  elearning: ElearningDataType | undefined;
  frames: FrameDataType[] | undefined;
  currentFrameId: string | undefined;
  resources: ResourceType[] | undefined;
  playerHelper: {
    content: HelperType[] | undefined;
    faq: FaqType[] | undefined;
  };
}

const PlayerLayout = ({
  top,
  canvas,
  bottom,
  className,
  elearning,
  frames,
  currentFrameId,
  resources,
  playerHelper,
}: PlayerLayoutType): ReactElement => {
  const cssPrefix = 'module-viewer';
  if (!elearning) {
    return <div className="loading" />;
  }
  return (
    <div className={`${cssPrefix}__wrapper`}>
      <div className={`${cssPrefix} ${className}`} id="ModuleViewer">
        <input
          type="hidden"
          name="interactive_image_link"
          id="interactive_image_link"
          value={`${config.learningModuleTemplatePath}images/rollover-ani_v3.gif`}
        />
        <div id="container">
          <ErrorBoundary
            FallbackComponent={SlideErrorFallback}
            onError={errorHandler}
          >
            <div className={`${cssPrefix}-style`}>{top}</div>
            <div id="content" className="canvas-editor">
              <div id="content-container">{canvas}</div>
              <Menu />
              <Resources />
              <Helper />
            </div>
          </ErrorBoundary>
          {bottom}
        </div>
      </div>
      <QuizHelper />
    </div>
  );
};

export default PlayerLayout;
